import { selectReportType } from "../../../../store/selectors/fieldsStateSelectors.ts";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { RunState } from "../../../viewer/storage/runState.ts";
import { selectAccountBookSettings } from "../../../../store/selectors/clientSettingsSelectors";
import { selectCurrentReportId, selectRefreshToken } from "../../../../store/selectors/currentReportSelectors";
import { selectLogQueries } from "../../../../store/selectors/devToolsSelectors";
import {
  selectDimensions,
  selectDimensionsStructureForCurrentReportType,
  selectMetaDataLoaded,
} from "../../../../store/selectors/metaDataSelectors";

const useSelectCommonData = (runState?: RunState) => {
  const preLoadedDimensions = runState?.dimensions;
  const reportType = useSelector(selectReportType) ?? undefined;
  const reportId = useSelector(selectCurrentReportId);
  const isQueryLoggingActive = useSelector(selectLogQueries);
  const refreshToken = useSelector(selectRefreshToken);
  const accountingBookSettings = useSelector(selectAccountBookSettings);
  const dimensionsStructure = useSelector(selectDimensionsStructureForCurrentReportType);

  const metaDimensions = useSelector(selectDimensions);
  const metaDataLoaded = useSelector(selectMetaDataLoaded);

  const dimensions = useMemo(() => {
    if (metaDataLoaded) {
      return metaDimensions.map((md) => {
        const preLoadedDictionary = preLoadedDimensions?.find((d) => d.name === md.name)?.dictionary;
        return {
          ...md,
          dictionary: preLoadedDictionary ?? md.dictionary,
        };
      });
    }
    return preLoadedDimensions ?? [];
  }, [metaDataLoaded, metaDimensions, preLoadedDimensions]);

  return {
    reportType: runState?.reportType ?? reportType,
    reportId,
    isQueryLoggingActive,
    refreshToken: runState?.refreshToken || refreshToken,
    dimensionsStructure,
    dimensions,
    books: runState?.books || accountingBookSettings?.books || [],
    isMultiBook: runState?.isMultiBook || accountingBookSettings?.multiBook || false,
  };
};

export default useSelectCommonData;
